import { useTranslation } from 'react-i18next'
import {
  I18N_CONFIG,
  LANGUAGE_LABELS,
  type SupportedLanguage,
} from '@/i18n/config.ts'

export function LanguageSwitcher() {
  const { i18n } = useTranslation()

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    i18n.changeLanguage(e.target.value)
  }

  return (
    <select
      value={i18n.language}
      onChange={handleChange}
      aria-label="Select language"
      className="border-line bg-surface-muted text-fg-secondary duration-fast hover:border-accent focus:border-accent [&_option]:bg-surface-muted [&_option]:text-fg cursor-pointer rounded-md border px-2 py-1.5 text-[0.8125rem] transition-[border-color] focus:outline-none"
    >
      {I18N_CONFIG.supportedLanguages.map((lang) => (
        <option key={lang} value={lang}>
          {LANGUAGE_LABELS[lang as SupportedLanguage]}
        </option>
      ))}
    </select>
  )
}
